<template>
  <div>
    <div class="app-detail pic-detail" v-if="type == 'reg_info' || type == 'assign' || wid">
      <div class="pic">
        <div class="title">
          上传{{ type != "import_ques_word" ? "Excel" : "Word" }}文件
        </div>
        <div class="pic-box">
          <van-uploader
            :before-read="beforeReadExcel"
            :after-read="afterRead"
            :max-count="1"
            v-if="excelUrl.length == 0"
            accept="*"
          >
            <div class="add-btn">
              <img
                src="https://cdn-xcxcustom.weiyoubot.cn/20210412/8e5c58cb2226eaa9b72d3fc17fee56d5.png"
              />
              <div class="add-btn-tip">上传文件</div>
            </div>
            <!-- <div style="word-break:break-all">{{href}}</div> -->
          </van-uploader>
          <div class="video-box" v-if="excelUrl.length > 0">
            <!-- <div class="delete-video" v-on:click="deleteExcel"><img src="../../assets/icon/ic_close_video.png"></div> -->
            <div class="excel-box">
              <div>{{ type != "import_ques_word" ? "Xls" : "Word" }}</div>
              <label v-if="isLoading">上传中....</label>
              <label v-else>
                {{ uploadStatus ? '上传成功，请点击下方"确定' : "上传失败" }}
                <button @click="clearExcelUrl" v-if="!uploadStatus">
                  重新上传
                </button>
              </label>
            </div>
          </div>
        </div>
      </div>
      <div class="btn-box" @click="backToMiniProgram">
        <button>确定</button>
      </div>
      <van-loading
        size="40px"
        text-size="14"
        vertical
        color="#fff"
        type="spinner"
        class="loading"
        v-if="isLoading"
        style="color:#fff;background-color:rgba(0,0,0,.6)"
        >上传中......{{ complete }}</van-loading
      >
    </div>
    <div class="guide-pc" v-else>
      <img
        class="pic-icon"
        src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20220316/78221d48bf06caecd576458f52985fc1.png"
      />
      <div class="info">
        <div class="title">题目较多的话，使用电脑版后台操作效率更高哦！</div>
        <div class="info-item">录入题目更方便</div>
        <div class="info-item">更多数据分析、题目错误率分析</div>
        <div class="tips">点击下方复制网址，使用电脑到浏览器打开。</div>
      </div>
      <div class="copy-btn"  v-clipboard:copy="copyText"
          v-clipboard:success="firstCopySuccess">
        复制电脑版网址：xiaoxiaodati.com
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import uploadHttp from "@/utils/picOnly";
import questionOnly from "@/utils/questionOnly";
import api from "@/utils/api";
import {
  getToken,
  isIos
} from "@/utils/common";
import config from "@/utils/config";
import { Toast, Dialog } from "vant";
let pollTimer = null;
let windowIndex = 0;

export default {
  data() {
    return {
      copyText: 'https://xiaoxiaodati.com',
      excelUrl: "",
      lists: [],
      fileType: "",
      isLoading: false,
      res: "",
      access_token: "",
      temp: 0,
      wid: "",
      regInfo: null,
      uploadStatus: true,
      type: ""
    };
  },
  created() {
    this.isIos = isIos();
  },
  mounted() {
    config.TOKEN = this.$route.query.token;
    this.temp = this.$route.query.temp || 0;
    this.wid = this.$route.query.wid || "";
    this.type = this.$route.query.type || "";
    this.qid = this.$route.query.qid || "";
    localStorage.setItem("token", this.$route.query.token);
  },
  components: {
    [Toast.name]: Toast,
    [Dialog.name]: Dialog
  },
  computed: {
    ...mapGetters({
      complete: "getComplete"
    })
  },
  methods: {
    firstCopySuccess() {
      Toast('复制成功');
    },
    clearExcelUrl() {
      this.excelUrl = "";
    },
    backToMiniProgram() {
      var self = this;
      let data = {};
      if (self.type === "reg_info") {
        data.regInfo = self.regInfo;
      } else {
        data = {
          excelUrl: self.excelUrl,
          lists: self.lists,
          version_code: 1
        };
      }
      wx.miniProgram.postMessage({
        data
      });
      wx.miniProgram.navigateBack({
        delta: self.type == "assign" ? 2 : 1
      });
    },
    deleteExcel() {
      this.excelUrl = "";
    },
    async afterRead(file) {
      var self = this;
      var url = api.question.upload;
      let formData = new window.FormData();
      formData.append("file", file.file);
      formData.append("access_token", getToken());
      formData.append(
        "type",
        self.type === "assign" || self.type === "reg_info"
          ? ""
          : self.type == "import_ques_word"
          ? "import_ques_word"
          : "import_ques"
      );
      formData.append("source", self.temp == 3 ? "ques" : "");
      formData.append("biz_id", self.wid || self.qid || "");
      formData.append("version_code", 1);
      try {
        uploadHttp.post(url, formData).then(res => {
          self.$store.state.complete = 0;
          setTimeout(() => {
            self.$store.state.complete++;
          }, 200);
          if (res.sta == 0) {
            var url = res.data.urls[0];
            self.excelUrl = url;
            self.polling();
          } else if (res.sta == -500) {
            Toast("登录过期，请返回小程序首页重新进入");
            self.isLoading = false;
          } else if (res.sta == -1) {
            self.isLoading = false;
            Toast(res.msg || "导入失败，请重试");
          }
        });
      } catch (e) {
      }
    },
    async polling() {
      let self = this;
      pollTimer = setTimeout(() => {
        // 判断是否为指定名单导入
        var url =
          self.type === "assign"
            ? api.question.assignExcelImport
            : self.type === "reg_info"
            ? api.question.regInfoExcelImport
            : api.question.importStatus +
              "?url=" +
              this.excelUrl +
              "&access_token=" +
              getToken();
        let data = {
          access_token: getToken(),
          spec_url: self.excelUrl,
          import_type: self.type === "assign" ? 0 : 1,
          qid: self.qid
        };
        // 如果得到结果，结束定时器，跳出递归，没有结果继续轮询，持续20次
        try {
          (self.type === "assign" || self.type === "reg_info"
            ? questionOnly.post(url, data)
            : uploadHttp.get(url)
          ).then(res => {
            windowIndex++;
            if (res.sta == 0) {
              clearTimeout(pollTimer);
              let lists = res.data;
              self.lists = lists;
              // if(self.wid) {
              //   self.itemAdd();
              // }else {

              // }
              if (self.type === "reg_info") {
                self.regInfo = res.data;
              }
              self.isLoading = false;
              self.uploadStatus = true;
              return;
            }
            if (res.sta == 2) {
              self.polling();
            } else if (res.sta == -500) {
              Toast("登录过期，请返回小程序首页重新进入");
              self.isLoading = false;
              self.uploadStatus = false;
              return;
            } else if (res.sta == -1) {
              Toast(res.msg || "导入失败，请重试");
              self.isLoading = false;
              self.uploadStatus = false;
              return;
            }
            if (windowIndex == 25) {
              windowIndex = 0;
              this.isLoading = false;
              this.uploadStatus = false;
              Toast("轮询次数过多，无响应，请退出重新尝试");
              clearTimeout(pollTimer);
              return;
            }
          });
        } catch (e) {
        }
      }, 3000);
    },
    async itemAdd() {
      var self = this;
      var url = api.question.warehouseAdd;
      let formData = {
        wid: this.wid,
        access_token: getToken(),
        type: 0,
        questions: this.lists
      };

      try {
        // uploadHttp
        uploadHttp.post(url, formData).then(res => {
          self.isLoading = false;
          self.$store.state.complete = 0;
          if (res.sta == 0) {
            Toast("添加成功");
            self.uploadStatus = true;
            return;
          } else if (res.sta == -500) {
            Toast("登录过期，请返回小程序首页重新进入");
            self.isLoading = false;
            self.uploadStatus = false;
          }
        });
      } catch (e) {
      }
    },
    beforeReadExcel(file) {
      this.isLoading = true;
      this.fileType = file.type;
      let type = file.type;
      if (this.type !== "import_ques_word") {
        if (
          type.indexOf("application/vnd.ms-excel") == -1 &&
          type.indexOf(
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          ) == -1
        ) {
          this.isLoading = false;
          Toast("请上传正确的excel文件");
          return false;
        }
      }
      return true;
    }
  }
};
</script>

<style scoped lang="scss">
@function rem($px) {
  @return $px * 2 / 75 + rem;
}

.app-detail {
  color: #666666;
  font-size: rem(14);
  .pic {
    background-color: #fff;
    padding: 0 rem(15);
    margin-bottom: rem(10);
    .delete-audio {
      width: rem(18);
      height: rem(18);
      position: absolute;
      right: 0;
      top: 0;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .title {
      height: rem(47);
      line-height: rem(47);
      color: #666;
      font-size: rem(15);
      span {
        font-size: rem(13);
      }
    }
    .pic-box {
      overflow: hidden;
      /deep/ .van-uploader__preview-image {
        width: rem(58);
        height: rem(58);
      }
      /deep/ .van-uploader__preview {
        width: rem(58);
        height: rem(58);
      }
      /deep/ .van-uploader__file {
        width: rem(58);
        height: rem(58);
      }
      .add-btn {
        width: rem(58);
        height: rem(58);
        border-radius: rem(5);
        display: flex;
        display: -webkit-flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-around;
        font-size: rem(12);
        border: 1px solid #eee;
        margin-bottom: rem(15);
        img {
          width: rem(25);
          height: rem(25);
          padding-top: rem(9);
        }
        .add-btn-tip {
          padding-bottom: rem(7);
        }
      }
    }
  }
  .video-box {
    position: relative;
    .delete-video {
      position: absolute;
      right: 0;
      top: 20px;
      z-index: 1;
      padding: rem(10);
      padding-top: 0;
      img {
        width: rem(20);
        height: rem(20);
      }
    }
    .excel-box {
      display: flex;
      align-items: center;
      padding-bottom: 10px;
      div {
        width: 50px;
        height: 50px;
        line-height: 50px;
        background: #28744a;
        border-radius: 4px;
        text-align: center;
        color: #fff;
        font-weight: 900;
        margin-right: 10px;
        font-size: rem(18);
      }
    }
  }
}
.guide-pc {
  margin: 0 15px;
}

.pic-icon {
  width: 345px;
  height: 154px;
  margin: 0 auto;
  display: block;
}

.info {
  background: #ffffff;
  border-radius: 4px;
  margin-top: 20px;
  font-size: 14px;
  padding: 15px;
  color: #262626;
  margin-bottom: 25px;
}

.title {
  margin-bottom: 10px;
  line-height: 21px;
}

.info-item {
  margin-top: 5px;
  position: relative;
  padding-left: 10px;
}

.info-item:before {
  position: absolute;
  left: 0;
  top: 8px;
  content: '';
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background-color: #1890ff;
}

.copy-btn {
  background: #1890FF;
  border-radius: 4px;
  height: 43px;
  line-height: 43px;
  text-align: center;
  font-size: 16px;
  color: #ffffff;
}
.tips{
  margin-top: 10px;
  line-height: 21px;
}
</style>



// WEBPACK FOOTER //
// src/pages/pic/pic.vue